import { LobbyImage } from '@colonist/types';
import { TimeUtils } from '../../../../../../../../shared/utils/TimeUtils.ts';
import { createButtonIn, createDivIn, createHeaderIn, createImgIn, createParagraphIn, setElementInnerHTML, setElementOnClick } from '../../../../../../../shared/scripts/ui_utils/DomUtils.ts';
import { UIMFullscreenPageView } from '../../../../../ui_page/UIMFullscreenPageView.ts';
import { uiManager } from '../../../../../EntryMobile.ts';
import { socket } from '../../../../../../../shared/scripts/EntryShared.ts';
import { isRankedMatchType } from '../../../../../../../shared/scripts/matchmaking/MatchmakingUtilsClient.ts';
import { getRandomMatchmakingTip } from '../../../../../../../shared/scripts/matchmaking/MatchmakingTipUtils.ts';
export class UIMMatchmakingSearchingView extends UIMFullscreenPageView {
    hide() {
        super.hide();
        clearInterval(this.timeElapsedInterval);
    }
    removeFromDOM() {
        super.removeFromDOM();
        clearInterval(this.timeElapsedInterval);
    }
    showSearchingView() {
        this.addTitle();
        this.mainContent = createDivIn(this.body, 'm-matchmaking-search-main');
        this.addImage();
        void this.addContent();
        this.addFooter();
        this.show();
    }
    show() {
        super.show();
        uiManager.adController.showBannerAds();
    }
    addTitle() {
        const divElement = createDivIn(this.body, 'm-matchmaking-search-header');
        this.titleContainer = createHeaderIn(divElement, this.loadingText, 'm-matchmaking-content', undefined, 'h2');
        this.currentCountElement = createHeaderIn(divElement, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: '...'
            }
        }, 'm-matchmaking-content', undefined, 'h2');
        const blankTime = '0:00';
        this.timeElapsedElement = createParagraphIn(divElement, {
            key: 'strings:homePage.matchmakingPopup.timeElapsed',
            options: {
                time: blankTime
            }
        }, 'm-matchmaking-content');
    }
    addImage() {
        const divElement = createDivIn(this.mainContent, 'm-matchmaking-search-image');
        createImgIn(divElement, this.imageSrc, 'm-gamemode-img');
        createImgIn(divElement, LobbyImage.MatchmakingSearch, 'm-gamemode-search-icon');
    }
    async addContent() {
        const divElement = createDivIn(this.mainContent, 'm-matchmaking-search-content');
        createHeaderIn(divElement, this.searchingTitle, 'm-matchmaking-content', undefined, 'h2');
        if (this.placementText != undefined) createParagraphIn(divElement, this.placementText, 'm-matchmaking-content');
    }
    addFooter() {
        const footerElement = createDivIn(this.body, 'm-matchmaking-search-footer');
        this.addTip(footerElement);
        this.createCancelButton(footerElement);
    }
    addTip(container) {
        const matchmakingTip = getRandomMatchmakingTip(this.matchType);
        if (matchmakingTip == undefined) return;
        createParagraphIn(container, matchmakingTip, 'm-matchmaking-content m-matchmaking-tip');
    }
    createCancelButton(container) {
        this.cancelButton = createButtonIn(container, 'button_cta_sub', {
            key: 'strings:colonistCommon.utils.emptyString'
        });
        createHeaderIn(this.cancelButton, {
            key: 'strings:colonistCommon.buttons.cancel'
        }, 'm-outlined', undefined, 'h2');
        setElementOnClick(this.cancelButton, ()=>this.matchmakingController.stopSearching());
    }
    updateStatus(matchmakingStatusUpdate) {
        this.cancelButton.disabled = false;
        const text = {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: `(${matchmakingStatusUpdate.numberOfPlayersFound}/${matchmakingStatusUpdate.totalNumberOfPlayersNeeded})`
            }
        };
        setElementInnerHTML(this.currentCountElement, text);
    }
    updatePlacementText(matchType) {
        if (!isRankedMatchType(matchType)) return;
        this.placementText = this.matchmakingController.matchmakingActionsController.getRankedPlacementText(matchType);
    }
    setTimeElapsedCounter() {
        this.timeElapsed = 0;
        this.timeElapsedInterval = setInterval(()=>{
            this.timeElapsed += 1;
            const newTimeString = TimeUtils.formatSecondsToElapsedString(this.timeElapsed);
            setElementInnerHTML(this.timeElapsedElement, {
                key: 'strings:homePage.matchmakingPopup.timeElapsed',
                options: {
                    time: newTimeString
                }
            });
        }, 1000);
    }
    buildView() {
        void this;
    }
    constructor(matchmakingController, title, imageSrc, loadingText, matchType){
        super({
            key: 'strings:colonistCommon.utils.emptyString'
        }, 'm-matchmaking-searching', ()=>undefined, 'matchmaking-searching-body', false), this.timeElapsed = 0;
        this.build();
        this.matchmakingController = matchmakingController;
        this.searchingTitle = title;
        this.imageSrc = imageSrc;
        this.loadingText = loadingText;
        this.matchType = matchType;
        this.updatePlacementText(matchType);
        this.showSearchingView();
        socket.controller.registerSocketCloseObserver(()=>this.matchmakingController.stopSearching());
    }
}
